import { atomWithStorage } from 'jotai/utils';
import { createResourceAtom } from 'lib/atoms';
import { useMemo } from 'react';
import { WellsResponse } from 'types/api-responses';
import type { WellPageSectionId } from 'components/well-page-content/well-page-sections';

/**
 * Which of the Well page's sections the "Layout settings" rail is showing.
 *
 * Sparse and default-on: an absent id reads as visible, so the record only holds what
 * the reader turned off. Keyed on {@link WellPageSectionId} so a renamed section is a
 * type error. Persisted per browser and not per well, since the choice describes how
 * this reader wants the page laid out rather than the well.
 */
const wellPageVisibleSectionsAtom = atomWithStorage<
  Partial<Record<WellPageSectionId, boolean>>
>('well-page-visible-sections', {}, undefined, { getOnInit: true });

const useWellAtom = (href: string, versionId?: string) => {
  const URL = versionId ? `${href}?version_id=${versionId}` : `${href}`;
  return useMemo(
    () => createResourceAtom<WellsResponse>(URL),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [href, versionId]
  );
};

export { useWellAtom, wellPageVisibleSectionsAtom };
